import Txt from "./Txt";
import Container from "./Container";
import AllBuildings from "../buildings-option/AllBuildings";

export default function OptionsContainer() {
  return (
    <Container>
      <Txt />
      <AllBuildings />
    </Container>
  );
}
